import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { createSavingsPolicyConfig } from "../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";

const SavingsPolicyPreview = ({ modal_id, data, policyCreateCloseRef }) => {
  const { gl_accounts } = useSelector((state) => state.accounting);
  const { cover } = useSelector((state) => state.policy);
  const { all_covers } = useSelector((state) => state.cover);
  const { offices } = useSelector((state) => state.office?.offices);
  const { unpaginated_life_cover } = useSelector((state) => state?.lifecover);

  const chargesList = ["ID Card", "Passport", "License", "TIN"];

  const appliedToOffice = offices?.filter((item) => item.id === data?.region_area_branch);

  const accountKeys = data?.policy_savings_accounting && Object.keys(data?.policy_savings_accounting);
  const glAccountsKeys = gl_accounts && Object.keys(gl_accounts?.accounts);

  const dispatch = useDispatch();

  return (
    <>
      <div
        id={modal_id}
        class='modal fade '
        tabindex='-1'
        role='dialog'
        aria-labelledby='fullWidthModalLabel'
        aria-hidden='true'
      >
        <div
          class='modal-dialog modal-full-width'
          style={{ maxWidth: "750px" }}
        >
          <div class='modal-content rounded-4'>
            <div class='modal-header'>
              <h4 class='modal-title text-primary-1' id='fullWidthModalLabel'>
                Preview Policy
              </h4>
              <button
                type='button'
                class='btn-close'
                data-bs-dismiss='modal'
                aria-hidden='true'
                data-backdrop='false'
                ref={policyCreateCloseRef}
              ></button>
            </div>
            <div class='modal-body'>
              <div className='row'>
                <div className='col-md-6 mb-2 '>
                  <label htmlFor='' className='form-labe mt-1'>
                    Name
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.policy_savings_general?.name}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Policy Code
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.policy_savings_general?.short_name}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Currency
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.policy_savings_general?.currency}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Minimum Duration(months)
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.policy_savings_general?.minimun_duration}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Minimum age
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.policy_savings_general?.minimum_age}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Maximum Age
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.policy_savings_general?.maximum_age}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Description{" "}
                  </label>
                  <div>
                    <textarea
                      name=''
                      id=''
                      cols='30'
                      className='form-control form-control-sm'
                      rows='3'
                      readOnly
                      defaultValue={data?.policy_savings_general?.description}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Life Cover</h5>
                <div className='row'>
                  {data?.life_cover?.map((life_cover, i) => {
                    const matchingCover = unpaginated_life_cover?.find(
                      (cover) => parseInt(cover.id) == life_cover
                    );

                    return (
                      matchingCover && (
                        <p className='my-1' key={i}>
                          {i + 1}. {matchingCover.life_cover_name}
                        </p>
                      )
                    );
                  })}
                </div>
              </div>
              <div>
                {data?.cover_type?.length > 0 && <h5 className='mt-3 fw-bolder text-primary-1'>Other Cover</h5>}
                <div className='row'>
                  {data?.cover_type?.map((cover_type, i) => {
                    const matchingCover = cover?.saving_covers?.find(
                      (cover) => parseInt(cover.id) == cover_type
                    );

                    return (
                      matchingCover && (
                        <p className='my-1' key={i}>
                          {i + 1}. {matchingCover.cover_name}
                        </p>
                      )
                    );
                  })}
                </div>
              </div>
              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Life Cover Claims</h5>
                {data?.life_cover_claim_name === "multiple" && (
                  <>
                    <span>Multiple</span>
                  </>
                )}
                <div className="mt-1">
                  {data?.value && data?.life_cover_claim_name === "multiple"
                    ? data?.value?.map((item, i) => (
                        <span
                          className='bg-primary text-light fs-6'
                          style={{ padding: "4px", margin: "0px 4px" }}
                          key={i}
                        >
                          {item.label}
                        </span>
                    ))
                  : null}
                </div>
                {data?.life_cover_claim_name === "assumed" && (
                  <>
                    <span>Assumed Sum Assured</span>
                  </>
                )}
                {data?.life_cover_claim_name === "guaranteed" && (
                  <>
                    <span>Guaranteed Sum Assured</span>
                  </>
                )}
                {data?.life_cover_claim_name === "guaranteed" && <div className='mt-1 mb-1'>
                    <strong>Guaranteed Type: </strong>
                    <span>{data?.guaranteed_type === 'fixed' ? "Fixed" : "Range"}</span>
                </div>}
                {data?.life_cover_claim_name === "guaranteed" && <div>
                  {data?.guaranteed_type === 'fixed' ? <div className='mt-1 mb-1 col-md-6'>
                    <input
                      type='text'
                      defaultValue={data?.value}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div> : 
                  <div className="row">
                    <div className="col-md-6">
                      <label htmlFor='' className='form-labe mt-1'>
                        Min.
                      </label>
                      <input
                        type='text'
                        defaultValue={data?.assumed_garranty_minimum}
                        className='form-control form-control-sm'
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor='' className='form-labe mt-1'>
                        Max.
                      </label>
                      <input
                        type='text'
                        defaultValue={data?.assumed_garranty_maximum}
                        className='form-control form-control-sm col-md-6'
                        readOnly
                      />
                    </div>
                  </div>
                  }
                </div>}
              </div>
              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Rate</h5>
                <div className='row'>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Default rate
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.policy_savings_interest?.default_rate}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Minimum rate
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.policy_savings_interest?.minimum_rate}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Maximum rate
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.policy_savings_interest?.maximum_rate}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                </div>
                {/* <div className='row'>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Interest Calculation Type
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.policy_savings_interest?.interest_cal_type}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Interest Posting Period
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.policy_savings_interest?.interest_posting_period}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Interest Compounding Period
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.policy_savings_interest?.interest_compound_period}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                </div> */}
              </div>
              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Account</h5>
                {accountKeys ? (
                  accountKeys?.map((item, i) => {
                    if (data?.policy_savings_accounting[item]) {
                      let gl_acc = glAccountsKeys?.map(
                        (el) => gl_accounts?.accounts[el]
                      );
                      const flattenedGlAcc = [].concat(...gl_acc);

                      let accountName = flattenedGlAcc
                        ?.map((el) => {
                          if (data?.policy_savings_accounting[item] === el?.id) {
                            return el?.account_name;
                          }
                        })
                        .filter((element) => element !== undefined);

                      return (
                        <div className='row' key={i}>
                          <div className='col-md-4 mb-2'>
                            <label
                              htmlFor=''
                              className='form-labe mt- text-capitalize'
                            >
                              {item?.split("_")[0]}
                            </label>
                            <input
                              type='text'
                              defaultValue={accountName[0]}
                              className='form-control form-control-sm'
                              readOnly
                            />
                          </div>
                        </div>
                      );
                    }
                  })
                ) : (
                  <p className='alert alert-warning '>No Account Selected</p>
                )}
              </div>
                {/* <div>
                    <h5 className='mt-3 fw-bolder text-primary-1'>Charges</h5>
                    <div className='row'>
                    <div className='col-md-12'>
                        <div className='charges'>
                        {data?.charges?.length ? (
                            data?.charges?.map((item, i) => (
                            <span
                                className='bg-primary text-light fs-6'
                                style={{ padding: "4px", margin: "0px 4px" }}
                                key={i}
                            >
                                {item.label}
                            </span>
                            ))
                        ) : (
                            <p className='alert alert-warning '>
                            No charges selected
                            </p>
                        )}
                        </div>
                    </div>
                    </div>
                </div> */}
                <div>
                    <h5 className='mt-3 fw-bolder text-primary-1'>Partial Withdrawal</h5>
                    <div className='row'>
                        <div className='col-md-6 mb-2'>
                            <label htmlFor='' className='form-labe mt-1'>
                            Max. withdrawal limit before maturity(%)
                            </label>
                            <input
                            type='text'
                            defaultValue={data?.partial_withdrawal?.max_withdrawal_limit}
                            className='form-control form-control-sm'
                            readOnly
                            />
                        </div>
                        <div className='col-md-6 mb-2'>
                            <label htmlFor='' className='form-labe mt-1'>
                            Withdrawal Penalty(%)
                            </label>
                            <input
                            type='text'
                            defaultValue={data?.partial_withdrawal?.withdrawal_penalty}
                            className='form-control form-control-sm'
                            readOnly
                            />
                        </div>
                        <div className='mb-1'>
                            <strong>Restrict withdrawal in the absence of savings activity until maturity: </strong>
                            <span>{data?.restrict_withdrawal ? "Yes" : "No"}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <h5 className='mt-3 fw-bolder text-primary-1'>Termination</h5>
                    <div className='row'>
                        <div className='col-md-6 mb-2'>
                            <label htmlFor='' className='form-labe mt-1'>
                            Penalty period (max.  in months)
                            </label>
                            <input
                            type='text'
                            defaultValue={data?.termination?.penalty_period}
                            className='form-control form-control-sm'
                            readOnly
                            />
                        </div>
                        <div className='col-md-6 mb-2'>
                            <label htmlFor='' className='form-labe mt-1'>
                            Penalty Value (%)
                            </label>
                            <input
                            type='text'
                            defaultValue={data?.termination?.penalty_value}
                            className='form-control form-control-sm'
                            readOnly
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div className='row'>
                        <div className='col-md-6 mb-2'>
                            <label htmlFor='' className='form-labe mt-1'>
                            Cool off period (max. in days)
                            </label>
                            <input
                            type='text'
                            defaultValue={data?.cool_off?.cool_off_period}
                            className='form-control form-control-sm'
                            readOnly
                            />
                        </div>
                        <div className='col-md-6 mb-2'>
                            <label htmlFor='' className='form-labe mt-1'>
                            Cool off Penalty (%)
                            </label>
                            <input
                            type='text'
                            defaultValue={data?.cool_off?.cool_off_value}
                            className='form-control form-control-sm'
                            readOnly
                            />
                        </div>
                    </div>
                </div>
              <div className=''>
                <h5 className='mt-3 fw-bolder text-primary-1'>
                  Apply to Office(s)
                </h5>
                {data?.apply_to === "CW" && (
                  <>
                    {/* <strong>Apply to: </strong> */}
                    <span>Company Wide</span>
                  </>
                )}
                {data?.apply_to === "SO" && (
                  <div className='mb-1'>
                    <strong>Specific Offices: </strong>
                    <div>
                      {data?.specific_offices && data?.apply_to === "SO"
                        ? data?.specific_offices?.map((item, i) => (
                            <span
                              className='bg-primary text-light fs-6'
                              style={{ padding: "4px", margin: "0px 4px" }}
                              key={i}
                            >
                              {item.label}
                            </span>
                          ))
                        : null}
                    </div>
                  </div>
                )}
                {data?.apply_to === "RAB" && (
                  <>
                    <div className='mb-1'>
                      <strong>Region/Area/Branch: </strong>
                      <span>{appliedToOffice[0]?.office_name}</span>
                    </div>
                    <div className='mb-1'>
                      <strong>Apply to Sub-offfices: </strong>
                      <span>{data?.apply_sub_offices ? "Yes" : "No"}</span>
                    </div>
                  </>
                )}
              </div>
              {data?.expires_at && (
                <div className='row'>
                  <h5 className='mt-3 fw-bolder text-primary-1'>Expires At</h5>
                  <span>{moment(data?.expires_at).format("LL")}</span>
                </div>
              )}
            </div>

            <div class='modal-footer'>
              <button
                type='button'
                class='btn btn-light'
                data-bs-dismiss='modal'
              >
                Close
              </button>
              <button
                type='button'
                class='btn btn-primary'
                onClick={() => {
                  let {
                    policy_savings_general,
                    policy_savings_accounting,
                    policy_savings_interest,
                    cover_type,
                    life_cover,
                    expires_at,
                    policy_cat_id,
                    specific_offices,
                    company_wide, sub_offices, partial_withdrawal, termination, cool_off, region_area_branch, restrict_withdrawal, life_cover_claim_name, guaranteed_type, assumed_garranty_minimum, assumed_garranty_maximum, value
                  } = data;
                  // charges = charges.map(item => ({ charge_id: item.value }));
                  // life_cover = life_cover.map(item => (item.value));
                  if (specific_offices) {
                    specific_offices = specific_offices.map(item =>  ({ office_id: item.value }))
                  }
                  if (sub_offices) {
                    sub_offices = 1;
                  }else {
                    sub_offices = 0;
                  }
                  if (restrict_withdrawal) {
                    restrict_withdrawal = 1;
                  }else {
                    restrict_withdrawal = 0;
                  }
                  if (life_cover_claim_name === 'multiple' ) {
                    value = value.map(item =>  ( item.value ))
                  }
                  dispatch(
                    createSavingsPolicyConfig({
                      policy_savings_general,
                      policy_savings_accounting,
                      policy_savings_interest,
                      other_cover: cover_type,
                      life_cover,
                      policy_cat_id,
                      company_wide, sub_offices, partial_withdrawal, termination, cool_off, expires_at, specific_offices, region_area_branch, restrict_withdrawal, life_cover_claim_name, guaranteed_type, assumed_garranty_minimum, assumed_garranty_maximum, value
                    })
                  );
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SavingsPolicyPreview;
